import style from "styled-components";

export const CartProduct = style.div`
    display:flex;
    flex-direction:row;
    border-top:0.5px solid lightgray;
    margin-left:1.1rem;
    justify-content:space-around;
    padding:2.0rem;
    width:60%;
    border-bottom:0.5px solid lightgray;
     @media(max-width:490px){
    flex-direction:column;
    width:80%;
  }
`;
export const Img = style.img`
       width:auto;
       height:200px;
`;
export const Body = style.div`
    display:flex;
    flex-direction:column; 
    margin-left:2.0rem;
`;

export const CartSpan = style.span`
   font-weight:900;
   text-align:center;
   margin:1.0rem;
`;
export const CartButton = style.button`
        border:none;
        background:transparent;
        &:hover{
            text-decoration:underline;
            cursor:pointer;
            opacity:0.9;
        }
        &:focus{
            outline:none;
        }
`;
export const Options = style.div`
display:flex;
flex-direction:column;
width:70%;
margin-right:1.0rem;
justify-content:flex-end;
font-size:${({ theme }) => theme.fontSizes.small};
@media(max-width:490px){
    justify-content:space-around;
    width:100%;
  }
`;

export const OptionsContainer = style.div`
    display:flex;
    flex-direction:row;
    justify-content:${(props)=> props.flex};
    margin:1.0rem;
`;

export const EmptyContainer = style.div`
   justify-content:center;
   text-align:center;
`;
